import { useSyncStore } from '../../store/syncStore.js';
import { useHubStore }  from '../../lib/hub.js';
import { IcoWarning, IcoArrowUp } from './Icons.jsx';

// Estado de conexión en el header. Con caja central hay dos tramos que
// importan: tablet ↔ caja (red local) y caja ↔ nube (internet). El mesero
// necesita saber cuál de los dos falló, porque se arreglan distinto.
export default function SyncBadge() {
  const isOnline     = useSyncStore((s) => s.isOnline);
  const pendingCount = useSyncStore((s) => s.pendingCount);
  const errorCount   = useSyncStore((s) => s.errorCount);
  const outboxCount  = useSyncStore((s) => s.outboxCount);
  const outboxErrors = useSyncStore((s) => s.outboxErrors);
  const hubUrl       = useHubStore((s) => s.hubUrl);
  const hubConnected = useHubStore((s) => s.connected);
  const hubName      = useHubStore((s) => s.hubName);

  // Lo primero, con hub o sin él: si una orden no ha salido de ESTE aparato,
  // no existe para nadie más. Es más urgente que cualquier retraso hacia la
  // nube, donde la cuenta ya está a salvo en la caja.
  if (outboxErrors > 0) {
    return (
      <span className="badge badge--error" title="El servidor rechazó estos cambios; hay que revisarlos" aria-label="El servidor rechazó estos cambios; hay que revisarlos">
        <IcoWarning size={12} /> {outboxErrors} orden{outboxErrors > 1 ? 'es' : ''} sin subir
      </span>
    );
  }
  if (outboxCount > 0) {
    return (
      <span className="badge badge--pending" title="Se subirán solas en cuanto vuelva la señal" aria-label="Se subirán solas en cuanto vuelva la señal">
        <IcoArrowUp size={11} /> {outboxCount} cuenta{outboxCount > 1 ? 's' : ''} por enviar
      </span>
    );
  }

  if (hubUrl) {
    if (!hubConnected) {
      return <span className="badge badge--offline" title={hubUrl} aria-label={hubUrl}>● Sin caja principal</span>;
    }
    if (!isOnline) {
      return (
        <span className="badge badge--pending" title="La caja opera sin internet; sincronizará al volver" aria-label="La caja opera sin internet; sincronizará al volver">
          ● {hubName ?? 'Caja'} · sin internet{pendingCount > 0 ? ` · ${pendingCount} por subir` : ''}
        </span>
      );
    }
    if (errorCount > 0) {
      return <span className="badge badge--error"><IcoWarning size={12} /> {errorCount} rechazado{errorCount > 1 ? 's' : ''} por la nube</span>;
    }
    if (pendingCount > 0) {
      return <span className="badge badge--pending"><IcoArrowUp size={11} /> Subiendo {pendingCount}…</span>;
    }
    return <span className="badge badge--online" title={hubUrl} aria-label={hubUrl}>● {hubName ?? 'Caja principal'}</span>;
  }

  if (!isOnline) {
    return <span className="badge badge--offline">● Sin internet{pendingCount > 0 ? ` · ${pendingCount} pendientes` : ''}</span>;
  }
  if (errorCount > 0) {
    return <span className="badge badge--error"><IcoWarning size={12} /> {errorCount} error{errorCount > 1 ? 'es' : ''}</span>;
  }
  if (pendingCount > 0) {
    return <span className="badge badge--pending"><IcoArrowUp size={11} /> Sincronizando…</span>;
  }
  return <span className="badge badge--online">● Online</span>;
}
